export default function Header() {
    return (
        <div className="header">
            <h1 id="title">
                Shift and Share your{" "}
                <span className="underline">Subtitles</span>
            </h1>
        </div>
    );
}
